import { render } from "./Deletion.vue?vue&type=template&id=a4b2144c&ts=true"
import script from "./Deletion.vue?vue&type=script&lang=ts"
export * from "./Deletion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__